import ScheduleItemModal from './ScheduleItemModal';
import './ScheduleItemModal.scss';

export default ScheduleItemModal;
